package diana.soleil.design.iraniancanadienbazzar.core.model

import kotlinx.serialization.Serializable

/**
 * Postal address of a business. [lat]/[lng] are null until geocoded (seeded candidates have none),
 * so map/distance features must treat coordinates as optional.
 */
@Serializable
data class Address(
    val line: String,
    val city: String,
    val province: String,
    val postalCode: String? = null,
    val country: String = "CA",
    val lat: Double? = null,
    val lng: Double? = null,
) {
    /** Single-line display, e.g. "120 Persian Lane, North York, ON". Skips blank parts. */
    fun formatted(): String =
        listOf(line, city, province).filter { it.isNotBlank() }.joinToString(", ")

    /**
     * Area-only display, e.g. "North York, ON" — no street line. Used when the exact address is
     * suppressed (home-based/residential listings), so the neighbourhood still helps discovery
     * without publishing someone's home. See [Business.displayAddress].
     */
    fun area(): String =
        listOf(city, province).filter { it.isNotBlank() }.joinToString(", ")
}
